import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HttpService from "../services/HttpServices";
import { toast } from "react-hot-toast";
const apiService = HttpService;

// Initial state of the slice
const initialState = {
  deliveryBoysData: [],
  allocatedOrders: [], // List of orders for the Boys
  deliveryManagerData: [], // List of orders for the Managers
  suppliers: [],
  vehicleDetails: [],
  countryDetails: [],
  stateDetails: [],
cityDetails: [],
  pinCodeDetails: [],
  dropPointDetails: [], // List of suppliers for a company
  productData: [],
  linkingorders: [],
  linkedOrder: null,
  orderDetails: null, // Details of a single order
  productDetails: null,
  linkedOrderDetails: null,
  uomDetails: null,
  pageCountAllocatedOrder: {},
  // loading: false,
  paginationInfo: {},
  error: null,
  updateOrder: {},
  paginationInfoLinkingOrder: {},
  loading: {
    fetchDeliveryBoys: false,
    fetchDeliveryManagers: false,
    createOrder: false,
    fetchOrderById: false,
    editOrder: false,
    linkedOrder: false,
    fetchSuppliersByCompanyId: false,
    fetchLinkingOrders: false,
    addProduct: false,
    fetchOrderDetails: false,
    unlinkOrder: false,
    placeOrder: false,
    cancelOrder: false,
    updateProduct: false,
    deleteOrderById: false,
    deleteOrderProduct: false,
    fetchUOMDetails: false,
    // Add more as needed...
  },
};

// Async thunk for fetching Delivery Boys...
export const fetchDeliveryBoys = createAsyncThunk(
  "deliveryModule/fetchDeliveryBoys",
  async (deliveryBoysData, { rejectWithValue }) => {
    try {
      const response = await apiService.post(
        "/api/web/deliveryboys/list",
        deliveryBoysData
      );
      toast.success(response.data.msg);
      console.log("Delivery Data :",response)
      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for addDeliveryBoy
export const addDeliveryBoy = createAsyncThunk(
  "order/addDeliveryBoy",
  async (boyData, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/api/web/deliveryboys/", boyData);
      toast.success(response.data.msg);
      console.log("Add Boy",response.data)
      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for fetching Manager Boys...
export const fetchDeliveryManagers = createAsyncThunk(
  "deliveryModule/fetchDeliveryManagers",
  async (d,{ rejectWithValue }) => {
    try {
      console.log("API call")
      const response = await apiService.post("/api/web/manager/list",d);
      toast.success(response.data.msg);
      console.log("Manager DATA ::",response.data)
      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for fetching Vehicles...
export const fetchVehicles = createAsyncThunk(
  "deliveryModule/fetchVehicles",
  async (vehiclesData, { rejectWithValue }) => {
    try {
      const response = await apiService.post(
        "/api/web/vehicle/list",
        vehiclesData
      );
      toast.success(response.data.msg);
      console.log("response.data :: ", response.data);
      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for fetching DropPoints...
export const fetchDropPoints = createAsyncThunk(
  "deliveryModule/fetchDropPoints",
  async (dropPointsData, { rejectWithValue }) => {
    try {
      const response = await apiService.post(
        "/api/web/drop-point/list",
        dropPointsData
      );
      toast.success(response.data.msg);
      console.log("response.data :: ", response.data);
      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Get Country Lists
export const getCountries = createAsyncThunk(
  "deliveryModule/getCountries",
  async (data, { rejectWithValue }) => {
    try {
      console.log("Country :::", data);

      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.get("/api/web/country", {
        params: data,
      });
      console.log("Country :::",response)
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Get State Lists
export const getStates = createAsyncThunk(
  "deliveryModule/getStates",
  async (stateData, { rejectWithValue }) => {
    try {
      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.post("/api/web/states/list",stateData);
      console.log("States :::", response.data);
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Get City Lists
export const getCities = createAsyncThunk(
  "deliveryModule/getCities",
  async (citiesData, { rejectWithValue }) => {
    try {
      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.post(
        "/api/web/cities/list",
        citiesData
      );
      console.log("Cities :::", response.data);
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Get PinCodes Lists
export const getPinCode = createAsyncThunk(
  "deliveryModule/getPinCode",
  async (pinCodeData, { rejectWithValue }) => {
    try {
      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.post(
        "/api/web/zipcodes/list",
      pinCodeData
      );
      console.log("PinCode :::", response.data);
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for creating an order
export const createOrder = createAsyncThunk(
  "order/createOrder",
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await apiService.post("/orders", orderData);
      toast.success(response.data.msg);

      return response.data; // response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error create Order!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Async thunk for fetching an order by ID
export const fetchOrderById = createAsyncThunk(
  "order/fetchOrderById",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/orders/${orderId}`);
      // console.log('OrderData', response.data)

      return response.data; // response
    } catch (error) {
      // console.error("Failed to fetch order details:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Async thunk for adding a product to an order
export const addProduct = createAsyncThunk(
  "order/addProduct",
  async ({ orderId, orderData }, { rejectWithValue }) => {
    try {
      // console.log('!!Add Product!!!',orderId,orderData)
      const url = `/orders/${orderId}/products`;
      const response = await apiService.post(url, orderData); // Adjust the endpoint as necessary
      console.log("!!respnse Product!!!", response);
      toast.success(response.msg);
      return response; //   the API responds with the added product data
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error Product!!!", error);
      return rejectWithValue(error.response?.data); // Ensure this matches your error handling strategy
    }
  }
);

// Async thunk for get Product Details order
export const fetchOrderDetails = createAsyncThunk(
  "order/fetchOrderDetails",
  async (orderId, { rejectWithValue }) => {
    try {
      const url = `/v2/orders/${orderId}/order-product`;
      const response = await apiService.get(url);
      return response.data; //   the API responds with order details
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
// Async thunk for Edit a product to an order
export const updateProduct = createAsyncThunk(
  "order/updateProduct",
  async ({ orderId, orderProductId, updateProducts }, { rejectWithValue }) => {
    console.log("!!update Product!!!", orderId, orderProductId, updateProducts);
    try {
      const response = await apiService.put(
        `/orders/${orderId}/products/${orderProductId}`,
        updateProducts
      );
      return response.data; // Assuming the API responds with the updated product data
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

export const deleteOrderProduct = createAsyncThunk(
  "order/deleteOrderProduct",
  async ({ orderId, orderProductId }, { rejectWithValue }) => {
    try {
      const response = await apiService.delete(
        `/orders/${orderId}/products/${orderProductId}`
      );
      // Assuming the API sends back a success message in response.data.msg
      toast.success(response.msg || "Product successfully deleted.");
      return response.data; // Assuming you want to work with the data part of the response
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "Failed to delete the product.";
      toast.error(errorMessage);
      console.log("!!error Deleting Product!!!", error);
      return rejectWithValue(
        error.response?.data || "An unexpected error occurred"
      );
    }
  }
);

// Async thunk for Delete a ORDER
export const deleteOrderById = createAsyncThunk(
  "orders/deleteOrderById",
  async ({ orderId }, { rejectWithValue }) => {
    try {
      // console.log('!!DELETE ORDER!!!',orderId)
      const response = apiService.delete(`/orders/${orderId}`);

      return response;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// update Order details
export const editOrder = createAsyncThunk(
  "order/editOrder",
  async ({ orderId, orderData }, { rejectWithValue }) => {
    try {
      const url = `/orders/${orderId}`;
      const response = await apiService.put(url, orderData); // put
      return response.data; //   your API returns the updated order data
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// linked Order
export const linkedOrder = createAsyncThunk(
  "order/linkedOrder",
  async ({ linkedOrderId, linkedOrderData }, { rejectWithValue }) => {
    try {
      console.warn("!!!!!Linked!!!!", linkedOrderId, linkedOrderData);

      const response = await apiService.patch(
        `/orders/${linkedOrderId}`,
        linkedOrderData
      ); // patch
      toast.success(response.data.msg);
      return response.data; //   your API returns the updated order data
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error linked!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// unlink Order
export const unlinkOrder = createAsyncThunk(
  "order/unlinkOrder",
  async ({ unLinkorderId, linkedOdata }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(
        `/orders/${unLinkorderId}`,
        linkedOdata
      );
      toast.success(response.data.msg);
      return response;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error unlinked!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Place Order
export const placeOrder = createAsyncThunk(
  "order/placeOrder",
  async ({ orderId, actionType }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(`/orders/${orderId}`, {
        // patch
        action: actionType,
      });
      toast.success(response.data.msg);
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error place!!!", error);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Cancel Order
export const cancelOrder = createAsyncThunk(
  "order/cancelOrder",
  async ({ orderId, cancelReason, action }, { rejectWithValue }) => {
    try {
      const response = await apiService.patch(`/orders/${orderId}`, {
        action,
        cancelReason,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// Get Suppliers by CompanyID
export const fetchSuppliersByCompanyId = createAsyncThunk(
  "order/fetchSuppliersByCompanyId",
  async (queryParams, { rejectWithValue }) => {
    try {
      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.get(
        "/orders/supplier-companies"
        // { params: queryParams },
      );
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Get Linking Order Lists
export const fetchLinkingOrders = createAsyncThunk(
  "order/fetchLinkingOrders",
  async (queryParams, { rejectWithValue }) => {
    try {
      // const response = await apiService.get(`/orders/supplier-companies?${companyKeyId}`);
      const response = await apiService.get("/orders/linking-orders", {
        params: queryParams,
      });
      return response.data; // Adjust if your API response structure is different
    } catch (error) {
      console.error("Failed to fetch suppliers:", error.message);
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
// Get fetch allocated Orders Lists
export const fetchAllocatedOrders = createAsyncThunk(
  "order/fetchAllocatedOrders",
  async ( assignOrderData , { rejectWithValue }) => {
    try {
      console.log("!!Get Allocated Orders!!!", assignOrderData);
      const url = `/api/web/order/all`;
      const response = await apiService.post(url, assignOrderData); // Adjust the endpoint as necessary
      console.log("!!respnse un/Allocated Orders!!!", response.data);
      toast.success(response.msg);
      return response.data; //   the API responds with the added product data
    } catch (error) {
      const errorMessage =
        error.response?.data?.msg || "An unexpected error occurred";
      toast.error(errorMessage);
      console.log("!!error Product!!!", error);
      return rejectWithValue(error.response?.data); // Ensure this matches your error handling strategy
    }
  }
);
// // Get fetch Unallocated Orders Lists
// export const fetchUnallocatedOrders = createAsyncThunk(
//   "order/fetchUnallocatedOrders",
//   async ( assignOrderData , { rejectWithValue }) => {
//     try {
//       console.log("!!Get Allocated Orders!!!", assignOrderData);
//       const url = `/api/web/order/all`;
//       const response = await apiService.post(url, assignOrderData); // Adjust the endpoint as necessary
//       console.log("!!respnse Product!!!", response.data.d);
//       toast.success(response.msg);
//       return response.data.d; //   the API responds with the added product data
//     } catch (error) {
//       const errorMessage =
//         error.response?.data?.msg || "An unexpected error occurred";
//       toast.error(errorMessage);
//       console.log("!!error Product!!!", error);
//       return rejectWithValue(error.response?.data); // Ensure this matches your error handling strategy
//     }
//   }
// );
// get UOM by type :
export const fetchUOMDetails = createAsyncThunk(
  "order/fetchUOMDetails",
  async ({ type }, { rejectWithValue }) => {
    try {
      const response = await apiService.get(`/orders/uom`, {
        params: { type },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);

// The order slice
export const deliverySlice = createSlice({
  name: "deliveryModule",
  initialState,
  reducers: {
    setOrder: (state, action) => {
      state.updateOrder = action.payload;
    },
    resetOrderState: (state) => {
      return { ...initialState, loading: { ...initialState.loading } };
    },
  },
  extraReducers: (builder) => {
    builder
      // Handling fetchDeliveryBoys
      .addCase(fetchDeliveryBoys.pending, (state) => {
        state.loading.fetchDeliveryBoys = true;
      })
      .addCase(fetchDeliveryBoys.fulfilled, (state, action) => {
        state.loading.fetchDeliveryBoys = false;
        state.deliveryBoysData = action.payload.d; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.count,
        };
      })
      .addCase(fetchDeliveryBoys.rejected, (state, action) => {
        state.loading.fetchDeliveryBoys = false;
        state.error = action.payload; // Ensure this is in a usable format
      })
      .addCase(fetchDeliveryManagers.pending, (state) => {
        state.loading.fetchDeliveryManagers = true;
      })
      .addCase(fetchDeliveryManagers.fulfilled, (state, action) => {
        state.loading.fetchDeliveryManagers = false;
        state.deliveryManagerData = action.payload.d; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.count,
        };
      })
      .addCase(fetchDeliveryManagers.rejected, (state, action) => {
        state.loading.fetchDeliveryManagers = false;
        state.error = action.payload; // Ensure this is in a usable format
      })

      .addCase(fetchVehicles.fulfilled, (state, action) => {
        state.loading.fetchVehicles = false;
        state.vehicleDetails = action.payload.d; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.count,
        };
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        // state.loading.f = false;
        state.countryDetails = action.payload.countries; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.count,
        };
      })
      .addCase(getStates.fulfilled, (state, action) => {
        // state.loading.fetchVehicles = false;
        state.stateDetails = action.payload.states; // This is your response.data.data
        // state.paginationInfo = {
        //   totalRecords: action.payload.count,
        // };
      })
      .addCase(getCities.fulfilled, (state, action) => {
        // state.loading.fetchVehicles = false;
        state.cityDetails = action.payload.cities; // This is your response.data.data
        // state.paginationInfo = {
        //   totalRecords: action.payload.count,
        // };
      })
      .addCase(getPinCode.fulfilled, (state, action) => {
        // state.loading.fetchVehicles = false;
        state.pinCodeDetails = action.payload.d; // This is your response.data.data
        // state.paginationInfo = {
        //   totalRecords: action.payload.count,
        // };
      })

      .addCase(fetchDropPoints.fulfilled, (state, action) => {
        state.loading.fetchDropPoints = false;
        state.dropPointDetails = action.payload.d; // This is your response.data.data
        state.paginationInfo = {
          totalRecords: action.payload.count,
        };
      })
      // Handling createOrder
      .addCase(createOrder.pending, (state) => {
        state.loading.createOrder = true;
      })
      .addCase(createOrder.fulfilled, (state, action) => {
        state.loading.createOrder = false;
        // Optionally update orders list or orderDetails with the newly created order
        state.orderDetails = action.payload; //   you want to view this order next
      })
      .addCase(createOrder.rejected, (state, action) => {
        state.loading.createOrder = false;
        state.error = action.payload;
      })
      // Handling fetchOrderById
      .addCase(fetchOrderById.pending, (state) => {
        state.loading.fetchOrderById = true;
      })
      .addCase(fetchOrderById.fulfilled, (state, action) => {
        state.loading.fetchOrderById = false;
        state.orderDetails = action.payload;
      })
      .addCase(fetchOrderById.rejected, (state, action) => {
        state.loading.fetchOrderById = false;
        state.error = action.payload;
      })
      .addCase(editOrder.pending, (state) => {
        state.loading.editOrder = true;
      })
      .addCase(editOrder.fulfilled, (state, action) => {
        state.loading.editOrder = false;

        state.orderDetails = action.payload;
      })
      .addCase(editOrder.rejected, (state, action) => {
        state.loading.editOrder = false;
        state.error = action.payload;
      })
      .addCase(linkedOrder.pending, (state) => {
        state.loading.linkedOrder = true;
      })
      .addCase(linkedOrder.fulfilled, (state, action) => {
        state.loading.linkedOrder = false;

        state.linkedOrder = action.payload;
      })
      .addCase(linkedOrder.rejected, (state, action) => {
        state.loading.linkedOrder = false;
        state.error = action.payload;
      })
      // Handling fetchSuppliersByCompanyId
      .addCase(fetchSuppliersByCompanyId.pending, (state) => {
        state.loading.fetchSuppliersByCompanyId = true;
      })
      .addCase(fetchSuppliersByCompanyId.fulfilled, (state, action) => {
        state.loading.fetchSuppliersByCompanyId = false;
        state.suppliers = action.payload; //   the payload is the suppliers list
      })
      .addCase(fetchSuppliersByCompanyId.rejected, (state, action) => {
        state.loading.fetchSuppliersByCompanyId = false;
        state.error = action.payload;
      })
      // Handling fetchSuppliersByCompanyId
      .addCase(fetchLinkingOrders.pending, (state) => {
        state.loading.fetchLinkingOrders = true;
      })
      .addCase(fetchLinkingOrders.fulfilled, (state, action) => {
        state.loading.fetchLinkingOrders = false;
        state.linkingorders = action.payload;
        state.paginationInfoLinkingOrder = {
          totalRecords: action.payload.totalRecords,
        };
      })
      .addCase(fetchLinkingOrders.rejected, (state, action) => {
        state.loading.fetchLinkingOrders = false;
        state.error = action.payload;
      })
      //  Handling Add Product in Orders
      .addCase(addProduct.pending, (state) => {
        state.loading.addProduct = true;
        state.error = null;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.loading.addProduct = false;
        state.productData = action.payload.data;
        state.error = null;
      })
      .addCase(addProduct.rejected, (state, action) => {
        state.loading.addProduct = false;
        state.error = action.payload;
      })
      //  Handling Add Product in Orders
      .addCase(fetchAllocatedOrders.pending, (state) => {
        state.loading.fetchAllocatedOrders = true;
        state.error = null;
      })
      .addCase(fetchAllocatedOrders.fulfilled, (state, action) => {
        state.loading.fetchAllocatedOrders = false;
        state.allocatedOrders = action.payload.d;
        state.pageCountAllocatedOrder = {
          totalRecords: action.payload.count,
        };
        state.error = null;
      })
      .addCase(fetchAllocatedOrders.rejected, (state, action) => {
        state.loading.fetchAllocatedOrders = false;
        state.error = action.payload;
      })
      // Handiling fetchOrdersProdcut by OrderId
      .addCase(fetchOrderDetails.pending, (state) => {
        state.loading.fetchOrderDetails = true;
        state.error = null;
      })
      .addCase(fetchOrderDetails.fulfilled, (state, action) => {
        state.loading.fetchOrderDetails = false;
        state.orderDetails = action.payload;
        state.error = null;
      })
      .addCase(fetchOrderDetails.rejected, (state, action) => {
        state.loading.fetchOrderDetails = false;
        state.error = action.payload;
      })
      .addCase(unlinkOrder.pending, (state) => {
        state.loading.unlinkOrder = true;
      })
      .addCase(unlinkOrder.fulfilled, (state, action) => {
        state.loading.unlinkOrder = false;
        state.linkedOrder = action.payload;
        // const index = state.data.findIndex(order => order.id === action.meta.arg.orderId);
        // if (index !== -1) state.data.splice(index, 1);
      })
      .addCase(unlinkOrder.rejected, (state, action) => {
        state.loading.unlinkOrder = false;
        state.error = action.payload;
      })
      // Place Order
      .addCase(placeOrder.pending, (state) => {
        state.loading.placeOrder = true;
      })
      .addCase(placeOrder.fulfilled, (state, action) => {
        state.loading.placeOrder = false;
        // Update your state as needed based on the action outcome  For example, updating the specific order's status to 'Placed'
        const index = state.orderData.findIndex(
          (order) => order.id === action.meta.arg.orderId
        );
        if (index !== -1) {
          state.orderData[index] = {
            ...state.orderData[index],
            status: "Placed",
          }; // Assuming the status field controls the order state
        }
      })
      .addCase(placeOrder.rejected, (state, action) => {
        state.loading.placeOrder = false;
        state.error = action.payload;
      })
      // Cancel Order
      .addCase(cancelOrder.pending, (state) => {
        state.loading.cancelOrder = true;
      })
      .addCase(cancelOrder.fulfilled, (state, action) => {
        state.loading.cancelOrder = false;
        // Update the state based on the action outcome
        // For example, marking the specific order as 'Canceled'
        const index = state.orderData.findIndex(
          (order) => order.id === action.meta.arg.orderId
        );
        if (index !== -1) {
          state.orderData[index] = {
            ...state.orderData[index],
            status: "Canceled",
            cancelReason: action.meta.arg.cancelReason,
          };
        }
      })
      .addCase(cancelOrder.rejected, (state, action) => {
        state.loading.cancelOrder = false;
        state.error = action.payload;
      })
      // Update Order Product
      .addCase(updateProduct.pending, (state) => {
        state.loading.updateProduct = true;
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.loading.updateProduct = false;
        state.productDetails = action.payload;
      })
      .addCase(updateProduct.rejected, (state, action) => {
        state.loading.updateProduct = false;
        state.error = action.payload;
      })
      // Delete Order by ID
      .addCase(deleteOrderById.pending, (state) => {
        state.loading.deleteOrderById = true;
        state.error = null;
      })
      .addCase(deleteOrderById.fulfilled, (state) => {
        state.loading.deleteOrderById = false;
        state.error = null;
      })
      .addCase(deleteOrderById.rejected, (state, action) => {
        state.loading.deleteOrderById = false;
        state.error = action.payload;
      })
      // Delete Order Product
      .addCase(deleteOrderProduct.pending, (state) => {
        state.loading.deleteOrderProduct = true;
      })
      .addCase(deleteOrderProduct.fulfilled, (state, action) => {
        state.loading.deleteOrderProduct = false;
        state.error = null;
        // const orderIndex = state.orderData.findIndex(order => order.id === action.payload.orderId);
        // if (orderIndex !== -1) {
        //   const products = state.orderData[orderIndex].products || [];
        //   state.orderData[orderIndex].products = products.filter(product => product.id !== action.payload.productId);
        // }
      })
      .addCase(deleteOrderProduct.rejected, (state, action) => {
        state.loading.deleteOrderProduct = false;
        state.error = action.payload;
      })
      // get UOM
      .addCase(fetchUOMDetails.pending, (state) => {
        state.loading.fetchUOMDetails = true;
      })
      .addCase(fetchUOMDetails.fulfilled, (state, action) => {
        state.loading.fetchUOMDetails = false;
        state.uomDetails = action.payload;
      })
      .addCase(fetchUOMDetails.rejected, (state, action) => {
        state.loading.fetchUOMDetails = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { resetOrderState, setOrder } = deliverySlice.actions;
export default deliverySlice.reducer;
